module.exports = __webpack_public_path__ + "images/re-screen-icon-138c0188.svg";